<main class="page-main">
  <div class="container layout layout--modal">
    <div class="layout__main">
      @if (showIntro) {
        <div class="question-stepper">
          <div class="question-stepper__img question-stepper__img--avatar">
            <img [src]="header?.avatar" class="icon" alt=""/>
          </div>
          <div class="question-stepper__content">
            <h3 class="font-normal" [innerHTML]="header?.body">
            </h3>
          </div>
        </div>
        <app-question-interstitial-generic [question]="null"></app-question-interstitial-generic>
      }
      @if (!showIntro) {
        <div class="card card--uw-summary">
          <div class="card-title">
            <div class="card-title__name">
              <svg class="icon icon--lg"><use xlink:href="#30px-profile"></use></svg>
              <h4 class="font-normal">{{first_name}} {{last_name}} </h4>
            </div>
            <!-- <div class="card-title__actions">
            <div class="dropdown">
              <a href="#" class="dropdown-toggle dropdown-toggle--everything dropdown-toggle--more d-none d-md-block" data-toggle="dropdown" aria-expanded="false">
                <svg class="icon"><use xlink:href="#more"></use></svg>
              </a>
              <a href="#modal-summary-actions" class="dropdown-toggle dropdown-toggle--everything dropdown-toggle--nocaret d-md-none" data-toggle="modal">
                <svg class="icon"><use xlink:href="#more"></use></svg>
              </a>
              <div class="dropdown-menu dropdown-menu-right dropdown-menu--everything">
                <a href="#" class="dropdown-item">
                  <svg class="icon"><use xlink:href="#profile"></use></svg>
                  <span>View Profile</span>
                </a>
              </div>
            </div>
          </div> -->
        </div>
        @if (isProfile) {
          <div class="card-body pt-40">
            <div class="form-group form-group--lg">
              <label>First Name</label>
              <!-- <input class="form-control" type="text" [(ngModel)]="first_name" value="" placeholder="" /> -->
              <app-question-controller
                [question]="{cent_aq_question_id: 0, answer: first_name, cent_aq_question_type_id: 2,question_prompt: 'First Name'}"
                (questionAnswer)="onChange($event)">
              </app-question-controller>
            </div>
            <div class="form-group form-group--lg">
              <label>Last Name</label>
              <!-- <input class="form-control" type="text" [(ngModel)]="last_name" value="" placeholder="" /> -->
              <app-question-controller
                [question]="{cent_aq_question_id: 0, answer: last_name, cent_aq_question_type_id: 2, question_prompt: 'Last Name'}"
                (questionAnswer)="onChange($event)">
              </app-question-controller>
            </div>
            <div class="form-group form-group--lg">
              <label>Email</label>
              <!-- <input class="form-control" type="email"  [(ngModel)]="person_email" value="" placeholder="" /> -->
              <app-question-controller
                [question]="{cent_aq_question_id: 0, answer: person_email, cent_aq_question_type_id: 51, question_prompt: 'Email'}"
                (questionAnswer)="onChange($event)">
              </app-question-controller>
            </div>
            <div class="form-group form-group--lg">
              <label>Mobile Number</label>
              <!-- <input class="form-control" type="text"  [(ngModel)]="person_tel" value="" placeholder="" /> -->
              <app-question-controller
                [question]="{cent_aq_question_id: 0, answer: person_tel, cent_aq_question_type_id: 52, question_prompt: 'Mobile'}"
                (questionAnswer)="onChange($event)">
              </app-question-controller>
            </div>
            @if (id_no) {
              <div class="form-group form-group--lg">
                <label>ID Number</label>
                <div class="input-group">
                  <input type="text" disabled=""  value="{{profile?.id_no}}" placeholder="" class="form-control">
                  <div class="input-group-append">
                    <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-html="true" data-placement="bottom" data-content="<div class=&quot;popover__content&quot;>Please call/chat to us if you would liekto change this detail.</div>" data-original-title="" title="">
                    <svg class="icon">
                      <use xlink:href="#info"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          }
          @if (passport) {
            <div class="form-group form-group--lg">
              <label>Passport Number</label>
              <div class="input-group">
                <input type="text" disabled=""  value="{{profile?.passport}}" placeholder="" class="form-control">
                <div class="input-group-append">
                  <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-html="true" data-placement="bottom" data-content="<div class=&quot;popover__content&quot;>Please call/chat to us if you would liekto change this detail.</div>" data-original-title="" title="">
                  <svg class="icon">
                    <use xlink:href="#info"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        }
        <div class="form-group form-group--lg">
          <label>Username</label>
          <div class="input-group">
            <input type="text" disabled=""  value="{{profile?.username}}" placeholder="" class="form-control">
            <div class="input-group-append">
              <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-html="true" data-placement="bottom" data-content="<div class=&quot;popover__content&quot;>Please call/chat to us if you would liekto change this detail.</div>" data-original-title="" title="">
              <svg class="icon">
                <use xlink:href="#info"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <!-- <label>Birthday</label>
      <app-question-controller
        [question]="{cent_aq_question_id: 0, answer: dob, cent_aq_question_type_id: 50}"
        (questionAnswer)="onDOBChange($event)">
      </app-question-controller>
      <div *ngIf="false" class="form-group form-group--lg">
        <div class="row row--xs">
          <div class="col col-sm-3">
            <div class="form-group form-group--sm mb-0">
              <label>Day</label>
              <input type="text" value="23" class="form-control">
            </div>
          </div>
          <div class="col col-5 col-sm">
            <div class="form-group form-group--sm mb-0">
              <label for="select-6">Month</label>
              <select id="select-6" class="ui-selectmenu">
                <option selected value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="2">May</option>
                <option value="3">June</option>
                <option value="4">July</option>
              </select>
            </div>
          </div>
          <div class="col col-4 col-sm-3">
            <div class="form-group form-group--sm mb-0">
              <label>Year</label>
              <input type="text" value="1991" class="form-control">
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-group--lg mb-15">
        <label>Main Address</label>
      </div>
      <app-question-controller
        [question]="{cent_aq_question_id: 0, answer: address, cent_aq_question_type_id: 3}"
        [controlCssClass]="'form-group form-group--sm ui-front'"
        [showLabel]="true"
        (questionAnswer)="onAddressChange($event)">
      </app-question-controller> -->
      @if (false) {
        <div class="address-fields" data-address-fields-idx="1" id="address_fields-1">
          <div class="form-group form-group--lg">
            <label>Main Address</label>
            <input type="text" id="address_unit-1" placeholder="Apt / Unit No. (optional)" class="form-control" />
          </div>
          <div class="form-group form-group--sm">
            <input type="text" id="address_complex-1" placeholder="Complex / Estate Name (optional)" class="form-control" />
          </div>
          <div class="form-group form-group--lg">
            <div class="form-control__wrap has-clear">
              <input type="search" value="" placeholder="Street address" id="pac-input-1" autocomplete="off" class="form-control" />
              <a href="#" id="clear-address-1" class="form-control__clear"><svg class="icon"><use xlink:href="#close-circle-small"></use></svg></a>
            </div>
            <div class="text-right mt-1">
              <img src="/assets/img/google-poweredby.svg" width="120" />
            </div>
          </div>
          <div class="form-group form-group--sm">
            <input type="text" id="address_suburb-1" placeholder="Suburb" class="form-control" />
          </div>
          <div class="form-group form-group--sm">
            <select id="address_province-1" class="ui-selectmenu">
              <option value="">Select Province</option>
              <option value="EC">Eastern Cape</option>
              <option value="FS">Free State</option>
              <option value="GP">Gauteng</option>
              <option value="KZN">KwaZulu-Natal</option>
              <option value="LP">Limpopo</option>
              <option value="MP">Mpumalanga</option>
              <option value="NC">Northern Cape</option>
              <option value="NW">North West</option>
              <option value="WC">Western Cape</option>
            </select>
          </div>
          <div class="form-group form-group--sm">
            <input type="text" id="address_city-1" placeholder="City" class="form-control" />
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group form-group--sm">
                <input type="text" id="address_postalcode-1" placeholder="Postal Code" class="form-control" />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (!isProfile) {
    <div class="card-body pt-40">
      @for (question of questions; track question) {
        @if (question?.cent_aq_question_type_id !==114 && question?.cent_aq_question_type_id !==33) {
          <app-question-controller
            [question]="question"
            [showLabel]="true"
            (questionAnswer)="questionAnswered($event)">
          </app-question-controller>
        }
        @if (question?.cent_aq_question_type_id === 114) {
          <div class="form-group form-group--lg">
            <app-question-email
              [question]="question"
              [showLabel]="true"
              (questionAnswer)="questionAnswered($event)">
            </app-question-email>
          </div>
        }
        @if (question?.cent_aq_question_type_id === 33) {
          <div class="form-group form-group--lg">
            <label>ID Number</label>
            <div class="input-group">
              <input type="text" disabled="" value="{{question?.answer}}" placeholder="" class="form-control">
              <div class="input-group-append">
                <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                  data-trigger="focus" data-html="true" data-placement="bottom"
                  data-content="<div class=&quot;popover__content&quot;>Please call/chat to us if you would liekto change this detail.</div>"
                  data-original-title="" title="">
                  <svg class="icon">
                    <use xlink:href="#info"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
}
</div>
</div>
</main>
<app-disclaimer></app-disclaimer>
<footer class="question-tray">
  <div class="container">
    <div class="question-tray__controls">
      <div class="question-tray__btns">
        @if (!showIntro) {
          <a href="javascript:;" data-toggle="modal" routerLink="/everything.policy-holders" class="button button--lg button--secondary">Cancel</a>
        }
        @if (!showIntro) {
          <a href="javascript:;" (click)="updateProfile()" class="button button--lg button--primary" id="save-btn">Save</a>
        }
        @if (showIntro) {
          <a href="javascript:;" (click)="showProfile()" class="button button--lg button--primary" id="save-btn">Got it!</a>
        }
      </div>
    </div>
  </div>
</footer>